import { getUrlParam, executeProtocol, isInHeybox } from '_lib/utils';
const isInHeyboxApp = isInHeybox();
import { reportDataWeb } from '_api/web-report';

class HeyboxReport {
  constructor() {
    this.observer = null;
    this.isScroll = false;
    this.hasReported = {};
    this._stayStatusMap = {};
    this.isIntersectionObserverSupported = judgeIntersectionObserverSupported();
    if (this.isIntersectionObserverSupported) {
      this.init();
    }
  }

  init() {
    if (!window._stayStatusCallback) {
      window._stayStatusCallback = () => {
        return JSON.stringify(this._stayStatusMap);
      };
    }
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (
            entry.target &&
            entry.boundingClientRect &&
            !(
              entry.boundingClientRect.width +
                entry.boundingClientRect.height ===
              0
            ) &&
            entry.intersectionRect &&
            !(
              entry.intersectionRect.width + entry.intersectionRect.height ===
              0
            )
          ) {
            const modifier = entry.target._modifier;
            if (modifier === 'exposure') {
              this.exposureCallback(entry);
              return;
            } else if (modifier === 'stay') {
              this.stayCallback(entry);
            }
          }
        });
      },
      { root: null, threshold: [0, 0.25, 0.5, 0.75, 1] },
    );
  }

  add(el) {
    if (!this.isIntersectionObserverSupported) {
      return;
    }
    this.observer && this.observer.observe(el);
  }

  remove(el) {
    if (!this.isIntersectionObserverSupported) {
      return;
    }
    this.observer && this.observer.unobserve(el);
  }

  // 曝光逻辑
  exposureCallback(entry) {
    const data = entry.target._reportParam;
    if (entry.intersectionRatio >= (data.threshold || 0.5)) {
      if (this.hasBeenReported(data.path, data.addition)) return;
      if (this.isScroll) {
        // 对于快速滚动的场景，需要延迟检测是否停留在可视区域
        if (entry.target.getAttribute('data-report-timer')) return;

        let timer = setTimeout(() => {
          const rect = entry.target.getBoundingClientRect();
          if (rect.y < 0 || rect.y > window.innerHeight) return;

          reportData('exposure', data);
          this.recordReport(data.path, data.addition || {});

          entry.target.removeAttribute('data-report-timer');
          this.remove(entry.target);
        }, 500);
        entry.target.setAttribute('data-report-timer', timer);
      } else {
        reportData('exposure', data);
        this.recordReport(data.path, data.addition || {});
        this.remove(entry.target);
      }
    } else {
      const timer = entry.target.getAttribute('data-report-timer');
      if (timer) {
        clearTimeout(timer);
        entry.target.removeAttribute('data-report-timer');
      }
    }
  }

  // 停留时长逻辑
  stayCallback(entry) {
    let { key } = entry.target._reportParam;
    if (entry.isIntersecting) {
      this.setStayStatus(key, 1);
      reportData('stay-start', entry.target._reportParam);
    } else {
      if (this.getStayStatus(key)) {
        this.clearStayStatus(key);
        reportData('stay-end', entry.target._reportParam);
      }
    }
  }

  setStayStatus(key, status) {
    this._stayStatusMap[key] = status;
  }

  getStayStatus(key) {
    return this._stayStatusMap[key];
  }

  clearStayStatus(key) {
    this.setStayStatus(key, undefined);
  }

  // 记录已经上报过的数据
  recordReport(path, addition) {
    if (!this.hasReported[path]) {
      this.hasReported[path] = [];
    }
    if (this.hasReported[path].indexOf(JSON.stringify(addition)) > -1) return;
    this.hasReported[path].push(JSON.stringify(addition));
  }

  hasBeenReported(path, addition) {
    if (!this.hasReported[path]) {
      return false;
    } else {
      return this.hasReported[path].indexOf(JSON.stringify(addition)) > -1;
    }
  }
}

export function reportData(reportType, reportParam) {
  // if (process.env.NODE_ENV == 'development') {
  //   return
  // }
  let { path, addition, key, suffix, mixin, h_src } = reportParam;
  if (!path) {
    path = `/web${window.location.pathname}${suffix ? '/' + suffix : ''}`;
  }
  const params = {
    path,
    addition: addition || {},
  };
  if (h_src) params.addition.h_src = btoa(h_src);
  // if (addition.h_src) {
  //   params.addition.h_src = btoa(addition.h_src)
  // }

  switch (reportType) {
    case 'visit':
      params.type = '1';
      params.protocol_type = 'trackData';
      break;
    case 'click':
      params.type = '4';
      params.protocol_type = 'trackData';
      break;
    case 'exposure':
      params.type = '3';
      params.protocol_type = 'trackData';
      break;
    case 'stay-start':
      Object.assign(params, {
        type: '1',
        key,
        protocol_type: 'trackDataEvent',
      });
      break;
    case 'stay-end':
      Object.assign(params, {
        type: '0',
        key,
        protocol_type: 'trackDataEvent',
      });
      break;
    default:
      break;
  }
  if (mixin && Object.prototype.toString.call(mixin) === '[object Object]') {
    Object.assign(params, mixin);
  }
  console.log('🚀 report', reportType, params);
  executeProtocol(params);
}

function bind(el, binding) {
  if (!isInHeyboxApp) return;
  const modifiers = binding.modifiers;
  const modifier = Object.keys(binding.modifiers).find((key) => modifiers[key]);

  el._reportParam = {
    ...(typeof binding.value == 'function'
      ? binding.value()
      : binding.value || {}),
    key: generateRandomString(),
  };
  el._modifier = modifier;

  switch (modifier) {
    // 主页面展示上报
    case 'visit':
      if (getUrlParam('source') === 'tab') {
        return;
      }
      reportData('visit', el._reportParam);
      break;
    // 点击上报
    case 'click':
      el.addEventListener('click', () => {
        reportData('click', el._reportParam);
      });
      break;
    // 曝光上报
    case 'exposure':
      if (!window.HeyboxReport) {
        window.HeyboxReport = new HeyboxReport();
      }
      window.HeyboxReport.add(el);
      break;
    // 停留时长
    case 'stay':
      if (!window.HeyboxReport) {
        window.HeyboxReport = new HeyboxReport();
      }
      window.HeyboxReport.add(el);
      break;
    default:
      break;
  }
}

function unbind(el, binding) {
  if (!isInHeyboxApp) return;
  let modifier = el._modifier;

  switch (modifier) {
    case 'exposure': {
      window.HeyboxReport.remove(el);
      break;
    }
    case 'stay': {
      let { key } = el._reportParam;
      window.HeyboxReport.clearStayStatus(key);
      window.HeyboxReport.remove(el);
      break;
    }
    default:
      break;
  }
}

function judgeIntersectionObserverSupported() {
  return (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  );
}

function generateRandomString() {
  return [...Array(16)]
    .map(() => (~~(Math.random() * 36)).toString(36))
    .join('');
}

export const HeyboxReportDirectiveOptions = {
  bind,
  unbind,
};

/**
 * 上报分享数据
 * @returns
 */
export const reportShare = ({
  action = 'visit', // 行为, visit, click_open, download
  extra = {}, // 额外信息
  source = window.location.pathname, // 标识业务
}) => {
  if (!action || isInHeyboxApp) {
    return;
  }
  const params = {
    path: `/web_share/${action}`,
    type: '1',
    addition: {
      open_source: source,
      page_identifier: JSON.stringify(extra),
    },
  };
  console.log('🚀 ~ share params:', params);
  reportDataWeb(params);
};

const install = (Vue) => {
  Vue.directive('report', HeyboxReportDirectiveOptions);

  Vue.prototype.$reportData = (type, params = {}) => {
    reportData(type, params);
  };

  Vue.prototype.$reportShare = reportShare;
};

export default install;
